import PendoButton from '../../button/pendo-button.vue.js';
import PendoTooltip from '../../../directives/tooltip/pendo-tooltip.js';

var script = {
  name: 'PendoActionsCell',
  components: {
    PendoButton
  },
  directives: {
    PendoTooltip
  },
  props: {
    row: {
      type: Object,
      required: true
    },
    actions: {
      type: Array,
      default: () => [{
        type: 'edit',
        icon: 'edit',
        tooltip: 'Edit'
      }, {
        type: 'duplicate',
        icon: 'copy',
        tooltip: 'Duplicate'
      }, {
        type: 'delete',
        icon: 'trash-2',
        tooltip: 'Delete'
      }]
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-actions-cell.vue2.js.map
